import React, { useEffect, useState } from "react";
import {
  getApplyList,
  setApplyList,
} from "../../../Requests/deltaHedgeAccounts";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { StaticMultiSelectDropdown } from "../../../Components/Dropdown/StaticMultiSelectDropdown";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getStepInstruments } from "../../../Requests/stepRequests";

interface IProps {
  onClose: () => void;
}

const ApplyList = ({ onClose }: IProps) => {
  const [selectedItems, setSelectedItems] = useState([] as string[]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getApplyList()
      .then((resp) => {
        setSelectedItems(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (_: string, value: any) => {
    setSelectedItems(value);
  };

  const onSubmit = () => {
    setLoading(true);
    setApplyList(selectedItems)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onClose();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3">
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "",
          placeholder: "نماد ها",
        }}
        getData={getStepInstruments}
        onChange={changeHandler}
        withTagBox
        value={selectedItems}
      />
      <div className="flex flex-row justify-start items-center gap-3 w-32 mr-auto mt-4">
        <Button onClick={onSubmit} text="تایید" variant="contained" />
      </div>
    </div>
  );
};

export default ApplyList;
